import React from "react";
import styled from "styled-components";

const SnsButton = props => {
  const { link, img, onClick } = props;
  return (
    <StyledButton onClick={onClick}>
      <img src={img} alt="sns-icon" />
    </StyledButton>
  );
};

export default SnsButton;

const StyledButton = styled.a`
  width: 2rem;
  height: 2rem;
  padding: 0.2rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #4d5257;
  cursor: pointer;
  > img {
    height: 1.2rem;
  }
`;
